import axios from "axios";
// import interceptors from "@/shared/api/interceptors";

// Bridge service (inqbox) — staff/employee lookups.
// Full paths resolve as `<baseURL>/<path>`, e.g.
//   POST /staff/employees/lookup -> https://inqbox.q19.kz/bridge/api/v1/staff/employees/lookup
const apiClientBridge = axios.create({
  baseURL: "https://inqbox.q19.kz/bridge/api/v1",
  headers: {
    "X-API-Secret": "019e6372-1fc2-760f-8ab6-9c80303b089e",
  },
});

// interceptors(apiClientBridge);
export default apiClientBridge;
